import { ICategory } from 'interfaces/category';
import { Observable, of } from 'rxjs';
import RxOp, { ICacheResult, IOptions } from 'rxjs-operators';

import apiService, { ApiService } from './api';
import selectedVentureService from './profile';

export class CategoryService {
  private key = 'category-structures';

  constructor(private apiService: ApiService) {}

  public fecthCategory(
    ventureId?: number,
    options?: Partial<IOptions>
  ): Observable<ICacheResult<ICategory[]>> {
    return this.apiService.get('/category', { ventureId }).pipe(
      RxOp.cache(this.key, {
        persist: true,
        refresh: false,
        expirationMinutes: 1,
        ...options,
      })
    );
  }

  public getById(categoryId?: number): Observable<ICategory> {
    return this.apiService.get(`/category/${categoryId}`);
  }

  public refreshCategory() {
    return selectedVentureService
      .getSelectedVenture()
      .subscribe((selection) => {
        if (selection && selection.id) {
          this.cleanCache().subscribe(() => {
            this.fecthCategory(selection.id, { refresh: true }).subscribe();
          });
        }
      });
  }

  public cleanCache() {
    return RxOp.cacheClean(this.key)(of(null));
  }
}

const categoryService = new CategoryService(apiService);
export default categoryService;
